import { b as a } from "./withEditable-7d0a220a.js";
import { jsx as r } from "react/jsx-runtime";
import { Image as p } from "@ucl/react-library/image";
import { u as c } from "./useViewPortProps-0c0b5cc6.js";
import "@adobe/aem-spa-page-model-manager";
import "html-react-parser";
import "sanitize-html";
import { s } from "./sanitizeProps-304c699d.js";
import "@adobe/aem-react-editable-components";
import "react";
import "./PageContext-57b2437f.js";
import "./component-a7888ba1.js";
import "./EditableComponentUtils-0b5699b7.js";
import "@ucl/react-library/useIsMounted";
import "./ComponentContext-3bb2d205.js";
import "./withErrorBoundary.js";
import "@ucl/shared-component-foundations/foundations";
import "styled-components";
import "./index-0371017d.js";
import "@ucl/react-library/useMediaQuery";
function n(o) {
  const { href: t, target: m, ...e } = c(o);
  return t ? /* @__PURE__ */ r("a", {
    href: t,
    target: m,
    onKeyDown: (i) => i.code === "Enter" && i.currentTarget.click(),
    rel: m === "_blank" ? "noopener noreferrer" : void 0,
    style: {
      display: "contents"
    },
    children: /* @__PURE__ */ r(p, {
      tabIndex: 0,
      ...s(e)
    })
  }) : /* @__PURE__ */ r(p, {
    ...s(e)
  });
}
n.displayName = "Image";
const g = (o) => {
  var t;
  return !((t = o.src) != null && t.trim().length);
}, l = "ucl/components/customimage", E = {
  emptyLabel: "Image",
  isEmpty: g,
  resourceType: l
}, G = a(E, n);
export {
  G as EditableImage,
  l as IMAGE_RESOURCE_TYPE
};
